module.exports = __webpack_public_path__ + "static/media/bg-proteins_mb.e76adc1c.jpg";